import App from './App.vue';

export default {
  path: '/CDS_VF_RefugeDetail',
  name: 'CDS_VF_RefugeDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '避難所詳細',
      controller: 'CDS_CTR_RefugeDetail',
    },
  },
};
